import React, { PureComponent } from "react";

import { AutoSizer } from "react-virtualized";

import numeral from "numeral";

import styles from "./style.module.css";

import { Treemap, Tooltip } from "recharts";

import WarningIcon from "images/warning.svg";

class CustomToolTip extends React.PureComponent {
  render() {
    const { active, payload, comparisonOptions, outcome, datasetSuccess } = this.props;

    if (!active || !payload || !payload[0] || !payload[0].payload) {
      return null;
    }

    const currPayload = payload[0].payload;

    return (
      <div className={styles.comparisonTooltip}>
        <div>
          <strong>{`${currPayload.name}`}</strong>
          <span>{` after `}</span>
          <strong>{`${comparisonOptions?.currentStart}`}</strong>
          <span>{`:`}</span>
        </div>
        <div className={styles.comparisonTooltipItem}>
          <div style={{ marginRight: "auto" }}>
            <span>{`Change in % of `}</span>
            <strong>{`${outcome}${datasetSuccess?.label ? ": " + datasetSuccess.label : ""}`}</strong>
            <span>{`:`}</span>
          </div>
          <div style={{ marginLeft: "10px", textAlign: "right", flexShrink: 0 }}>
            <span>
              {(currPayload.rawData?.difference > 0 ? "+" : "") +
                numeral(currPayload.rawData?.difference).format("0.[00]") +
                "% pp"}
            </span>
          </div>
        </div>
        <div className={styles.comparisonTooltipItem}>
          <div style={{ marginRight: "auto" }}>
            <span>{`Change in % of `}</span>
            {/* <strong>{`${currPayload.column}`}</strong> */}
            <span>{`Total Count: `}</span>
          </div>
          <div style={{ marginLeft: "10px", textAlign: "right", flexShrink: 0 }}>
            <span>
              {(currPayload.rawData?.countChange > 0 ? "+" : "") +
                numeral(currPayload.rawData?.countChange).format("0.[00]") +
                "% pp"}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

class CustomizedContent extends PureComponent {
  render() {
    const { root, depth, x, y, width, height, index, payload, color, rank, name, hideLabels } = this.props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: depth < 2 ? color : "transparent",
            stroke: "#fff",
            strokeWidth: hideLabels && depth > 1 ? 0 : 2 / (depth + 1e-10),
            strokeOpacity: hideLabels && depth > 1 ? 0 : 1 / (depth + 1e-10)
          }}
        />
        {depth === 1 && !hideLabels && width > name.length * 5 ? (
          <text x={x + width / 2} y={y + height / 2 + 7} textAnchor="middle" fill="#fff" fontSize={13}>
            {name}
          </text>
        ) : null}
        {/* {depth === 1 && !hideLabels  ? (
          <text x={x + 4} y={y + 18} fill="#fff" fontSize={16} fillOpacity={0.9}>
            {index + 1}
          </text>
        ) : null} */}
      </g>
    );
  }
}

export default class ComparisonChart extends PureComponent {
  render() {
    const {
      dataset,
      rankedFields,
      width,
      height,
      showTitle,
      hoverGroup,
      hoverRibbon,
      gridType,
      hoverNode,
      isFixSvg,
      isSmall,
      isReport,
      isReportMuscle,
      isHideSearch,
      insight,
      isSense,
      isTiny,
      isHoverInsights,
      hideChords,
      searchOptions,
      isSenseTile,
      isNextReport,
      isMedium,
      isSenseSmallOld,
      isTableau,
      node,
      isExploreTask,
      handleMuscleClick,
      innerRadius,
      isReportExpand,
      insights,
      comparisonOptions,
      isLoading,

      outcome,
      datasetSuccess
    } = this.props;

    if (dataset === undefined || dataset.fields === undefined || insights === undefined) {
      return <div />;
    }

    if (!insights?.length) {
      return (
        <div className={styles.comparisonWarningWrapper}>
          <div className={styles.comparisonWarningIcon}>
            <img src={WarningIcon} />
          </div>
          <div className={styles.comparisonWarningTitle}>
            {
              "No insights found. Please review the problematic predictor warnings for this dataset. Removing problematic predictors can help uncover insights in the data."
            }
          </div>
        </div>
      );
    }

    const isSenseSmall = !isHoverInsights && isSenseTile;

    const dateField = comparisonOptions?.dateField;

    const dataByColumn = {};

    insights.forEach((insight) => {
      const score = insight.sortScore;
      const iMetadata = insight.metadata?.properties.find((p) => p.column !== dateField);
      const column = iMetadata?.column;
      if (!dataByColumn[column]) {
        dataByColumn[column] = {
          name: column,
          color: insight.color,
          totalCount: 0,
          children: []
        };
      }
      const name = insight.narrative?.conditionTitle ?? insight.title?.split(dateField + " when ").join("");

      dataByColumn[column].children.push({
        name: name,
        column: column,
        rawDifference: insight.difference,
        rawData: insight.differenceRawData,
        difference: insight.sortScore
      });
    });

    const treeMapData = Object.values(dataByColumn)
      .map((cData) => {
        const totalDiff = cData.children.reduce((acc, c) => c.difference + acc, 0);
        cData.totalDifference = totalDiff;
        return cData;
      })
      .sort((a, b) => {
        const aDiff = a.totalDifference;
        const bDiff = b.totalDifference;
        return bDiff - aDiff;
      });

    return (
      <div
        className={
          isExploreTask
            ? styles.leakageChartTask
            : isNextReport
              ? styles.leakageChartRep
              : isSenseSmallOld
                ? styles.leakageChartSenseOld
                : isMedium
                  ? styles.leakageChartSenseMed
                  : isHoverInsights
                    ? styles.leakageChartSenseLarge
                    : isSenseSmall
                      ? styles.leakageChartSenseSmall
                      : isSense
                        ? styles.leakageChartSense
                        : isReport
                          ? styles.leakageChartReport
                          : styles.leakageChart
        }
        id={isNextReport ? "leakageSizer" : isFixSvg ? "leakageChart" : "oLeakageChart"}
        style={{
          padding: "10px"
        }}
      >
        {isLoading && (
          <div className={styles.notImportant}>
            <div />
          </div>
        )}
        {isNextReport ? (
          <AutoSizer>
            {({ width, height }) => (
              <Treemap
                data={treeMapData}
                width={width}
                height={width}
                dataKey={"difference"}
                ratio={1.25}
                stroke={"#FFFFFF"}
                fill={"#7E69D7"}
                // strokeWidth={isSenseSmall || hideChords ? 0 : 1}
                strokeWidth={1}
                isAnimationActive={false}
                content={<CustomizedContent />}
              >
                <Tooltip
                  // allowEscapeViewBox={{ x: true, y: true }}
                  content={
                    <CustomToolTip
                      comparisonOptions={comparisonOptions}
                      outcome={outcome}
                      datasetSuccess={datasetSuccess}
                    />
                  }
                ></Tooltip>
              </Treemap>
            )}
          </AutoSizer>
        ) : (
          <Treemap
            data={treeMapData}
            width={isSmall ? width * 0.5 : width}
            height={isSmall ? height * 0.5 : height}
            dataKey={"difference"}
            ratio={1.25}
            stroke={"#FFFFFF"}
            fill={"#7E69D7"}
            // strokeWidth={isSenseSmall || hideChords ? 0 : 1}
            strokeWidth={1}
            isAnimationActive={false}
            content={<CustomizedContent hideLabels />}
          />
        )}
      </div>
    );
  }
}
